import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';
import { CourseState } from '../reducers/course.reducer';

const selectCourseState = createSelector(selectState, (state) => state.course);

export const selectLoaded = (id: string) => createSelector(selectCourseState, (state: CourseState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectCourseState, (state: CourseState) => (state.items[id] ? state.items[id].loading : false));
export const selectCourse = (id: string) => createSelector(selectCourseState, (state: CourseState) => (state.items[id] ? state.items[id].data : null));
